import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  constructor(
    private Http: HttpClient
  ) {}

  getAuthToken(data) {
    const params = new HttpParams()
      .set('username', data.username)
      .set('password', data.password)
      .set('grant_type', data.grant_type)
      .set('authority', data.authority)
    return this.Http.post(environment.javaServerUrl + '/oauth/token', params)
  }

  getUserRoles() {
    return this.Http.get(environment.javaServerUrl + '/admin/user/get/role')
  }

  setUserRole(data) {
    return this.Http.post(environment.javaServerUrl + '/admin/user/save/activerole', data)
  }
}
